import React from 'react';
import { Clock, Check, Info } from 'lucide-react';
import { tours, bookingInfo, partners, siteInfo } from '../mock';

const Tours = () => {
  return (
    <section id="ridturer" className="py-24 md:py-36 bg-[#f1ece0] grain relative">
      <div className="max-w-7xl mx-auto px-6 md:px-10 relative">
        <div className="text-center max-w-2xl mx-auto mb-16 md:mb-20 reveal">
          <p className="text-[#8a8572] text-xs uppercase tracking-[0.4em] mb-5">— Ridturer</p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-[#2f3d30] leading-[1.05] mb-6">
            Välj din <em className="italic font-light">upplevelse</em>.
          </h2>
          <p className="text-[#4a4a45] font-light leading-relaxed">
            Planerad start på sommarsäsongen: <span className="text-[#2f3d30] font-medium">{siteInfo.seasonStart}</span>. Längre turer och arrangemang kan ordnas efter överenskommelse.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {tours.map((t, idx) => (
            <article
              key={t.id}
              className="reveal lift bg-[#faf7f2] border border-[#e8e1d2] overflow-hidden group"
              style={{ transitionDelay: `${idx * 80}ms` }}
            >
              <div className="img-zoom aspect-[4/3] overflow-hidden relative">
                <img src={t.image} alt={t.name} className="w-full h-full object-cover" />
                {t.popular && (
                  <span className="absolute top-4 left-4 bg-[#2f3d30] text-[#f6efe2] text-[10px] uppercase tracking-[0.2em] px-3 py-1.5">
                    Populärast
                  </span>
                )}
              </div>
              <div className="p-7 md:p-8">
                <div className="flex items-center gap-2 text-[#8a8572] text-xs mb-3">
                  <Clock className="w-3.5 h-3.5" strokeWidth={1.5} />
                  <span className="uppercase tracking-[0.2em]">{t.duration}</span>
                </div>
                <h3 className="font-display text-3xl md:text-[34px] text-[#2f3d30] mb-3">
                  {t.name}
                </h3>
                <p className="text-[#4a4a45] text-sm leading-relaxed font-light mb-6">
                  {t.description}
                </p>
                <div className="flex items-baseline justify-between pt-5 border-t border-[#e8e1d2]">
                  <div>
                    <span className="font-display text-3xl text-[#2f3d30]">{t.price}</span>
                    <span className="text-[11px] text-[#8a8572] ml-2">{t.priceNote}</span>
                  </div>
                  <a
                    href="#kontakt"
                    className="text-xs uppercase tracking-[0.2em] font-medium text-[#2f3d30] border-b border-[#2f3d30] pb-0.5 hover:text-[#8a6a3a] hover:border-[#8a6a3a] transition-colors"
                  >
                    Boka
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-20 grid lg:grid-cols-2 gap-10 reveal">
          <div className="bg-[#faf7f2] border border-[#e8e1d2] p-8 md:p-10">
            <h4 className="font-display text-2xl text-[#2f3d30] mb-5 flex items-center gap-3">
              <Info className="w-5 h-5 text-[#8a6a3a]" strokeWidth={1.5} /> Bra att veta
            </h4>
            <ul className="space-y-3 text-[14px] text-[#4a4a45] font-light leading-relaxed">
              <li className="flex gap-3">
                <Check className="w-4 h-4 text-[#2f3d30] mt-1 flex-shrink-0" strokeWidth={1.5} />
                <span><strong className="text-[#2f3d30] font-medium">Ridvana krävs:</strong> {bookingInfo.ridvana}</span>
              </li>
              <li className="flex gap-3">
                <Check className="w-4 h-4 text-[#2f3d30] mt-1 flex-shrink-0" strokeWidth={1.5} />
                <span><strong className="text-[#2f3d30] font-medium">Ta med:</strong> {bookingInfo.equipment}</span>
              </li>
              <li className="flex gap-3">
                <Check className="w-4 h-4 text-[#2f3d30] mt-1 flex-shrink-0" strokeWidth={1.5} />
                <span><strong className="text-[#2f3d30] font-medium">Betalning:</strong> {bookingInfo.payment}</span>
              </li>
              <li className="flex gap-3">
                <Check className="w-4 h-4 text-[#2f3d30] mt-1 flex-shrink-0" strokeWidth={1.5} />
                <span><strong className="text-[#2f3d30] font-medium">Avbokning:</strong> {bookingInfo.cancellation}</span>
              </li>
              <li className="flex gap-3 pt-2">
                <span className="italic text-[#8a6a3a]">{bookingInfo.tax}</span>
              </li>
            </ul>
          </div>

          <div className="bg-[#2f3d30] text-[#f6efe2] p-8 md:p-10">
            <h4 className="font-display text-2xl mb-5">Våra samarbetspartners</h4>
            <p className="text-[#d6ceba] text-sm font-light leading-relaxed mb-7">
              Vi erbjuder även boende via våra samarbetspartners i Ljungdalen.
            </p>
            <ul className="space-y-3">
              {partners.map((p) => (
                <li key={p.name}>
                  <a
                    href={p.url}
                    target="_blank"
                    rel="noreferrer"
                    className="group flex items-center justify-between py-3 border-b border-[#4a5a4a] hover:border-[#e8d8b4] transition-colors"
                  >
                    <span className="text-[15px] group-hover:text-[#e8d8b4] transition-colors">
                      {p.name}
                    </span>
                    <span className="text-xs opacity-60 group-hover:opacity-100 group-hover:translate-x-1 transition-all">
                      →
                    </span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Tours;
